// DS4.4
import React from 'react';
import c from 'classnames';
import InputHint from '../../lego/InputHint';
import InputLabelSubText from '../../lego/InputLabelSubText';
import InputLabelText from '../../lego/InputLabelText';
import InputErrorMessage from '../../lego/InputErrorMessage';
import InputSuccessMessage from '../../lego/InputSuccessMessage';
import FormElement from '../../layouts/FormElement';
import Checkbox from '../../../Checkbox';
import MainToggle from '../MainToggle';
import s from './BooleanInput.scss';
/**
 * A boolean field, either in toggle or checkbox format.
 */ const BooleanInput = /*#__PURE__*/ React.forwardRef(({ id, name, label, subLabel, details, className, labelClassName, validationResult, noBottomSpacing, innerRef, biData, tabIndex, disabled = false, value = false, size = 'small', type = 'checkbox', onChange }, ref)=>{
    let wrappedDetails;
    const errorMessageId = `${id}-error`;
    const hintId = `${id}-hint`;
    const onLabelClick = (ev)=>{
        // If a link inside the label was clicked, avoid changing the checkbox value
        const target = ev.target;
        if (target.tagName.toLowerCase() === 'a') {
            ev.stopPropagation();
            return;
        }
        if (!disabled) {
            onChange(!value, ev);
        }
    };
    switch(validationResult){
        case 'success':
            wrappedDetails = details && /*#__PURE__*/ React.createElement(InputSuccessMessage, null, details);
            break;
        case 'error':
            wrappedDetails = details && /*#__PURE__*/ React.createElement(InputErrorMessage, {
                id: errorMessageId
            }, details);
            break;
        default:
            wrappedDetails = details && /*#__PURE__*/ React.createElement(InputHint, {
                id: hintId
            }, details);
    }
    return /*#__PURE__*/ React.createElement(FormElement, {
        className: c(className, s[`size-${size}`], disabled && s['disabled']),
        inputId: id,
        label: label,
        isLabelHidden: true,
        subLabel: subLabel && /*#__PURE__*/ React.createElement(InputLabelSubText, null, subLabel),
        details: wrappedDetails,
        tabIndex: tabIndex,
        noBottomSpacing: noBottomSpacing,
        ref: ref
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['wrapper']
    }, type === 'checkbox' && /*#__PURE__*/ React.createElement(Checkbox, {
        ariaLabelledBy: `${id}-label`,
        // checkbox has small and big (no medium or large)
        size: size === 'small' ? 'small' : 'big',
        onChange: onChange,
        isChecked: value,
        disabled: disabled,
        name: name,
        biData: biData,
        tabIndex: tabIndex,
        innerRef: innerRef
    }), type === 'toggle' && /*#__PURE__*/ React.createElement(MainToggle, {
        variant: "main",
        "aria-labelledby": `${id}-label`,
        size: 'small',
        onChange: onChange,
        value: value,
        tabIndex: tabIndex,
        disabled: disabled,
        biData: biData,
        innerRef: innerRef
    }), /*#__PURE__*/ React.createElement(InputLabelText, {
        className: c(s['label-text'], labelClassName),
        onClick: onLabelClick
    }, label)));
});
BooleanInput.displayName = 'BooleanInput';
export default BooleanInput;

//# sourceMappingURL=BooleanInput.js.map